// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectReportGroupResponse extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_REPORT_GROUP_RESPONSE);
        this.Tables = [];
    }
}
export class ReportTable {
}
export class ReportColumn {
}
